import { userManager } from '../auth/authService';
import { useRunOnce } from '../hooks/useRunOnce';

/**
 * Loaded in an iframe for OIDC silent renew. Must match `silent_redirect_uri` in Cognito app client settings.
 */
const SilentAuthCallback = () => {
  useRunOnce(() => {
    void userManager.signinSilentCallback().catch((err) => {
      console.error('Silent auth callback error', err);
    });
  });

  return null;
};

export default SilentAuthCallback;
